import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router";
import useGetCaseDocumentationQuery from "../hooks/useGetCaseDocumentationQuery";

import CaseTranscriptDrawer from "./CaseTranscriptDrawer";
import CaseDocumentationItem from "./CaseDocumentationItem";
import { MODIFIED_CASE_DOCUMENTATION } from "../types/CommonTypes";
import EmptyComponent from "../../../components/EmptyComponent";

const CaseDocumentation: React.FC = () => {
  const { caseId } = useParams();

  const { data: caseDocumentationListData } =
    useGetCaseDocumentationQuery(caseId);

  const caseDocumentationList = useMemo(() => {
    return caseDocumentationListData
      ?.reduce((acc, item) => {
        const existingSection = acc.find(
          (s: any) => s.sectionName === item.sectionName
        );
        if (existingSection) {
          const entriesCount = Math.max(item.totalEntries - 1, 0);
          existingSection.actualEntries = Math.max(
            existingSection.actualEntries,
            entriesCount
          );
          existingSection.entity.push({
            entityName: item.entityName,
            entries: item.entries,
            totalEntries: entriesCount,
            latestEntry: item.latestEntry,
            entityType: item.entityType,
            enumValues: item.enumValues,
          });
        } else {
          const entriesCount = Math.max(item.totalEntries - 1, 0);
          acc.push({
            sectionName: item.sectionName,
            actualEntries: entriesCount,
            entity: [
              {
                entityName: item.entityName,
                entries: item.entries,
                totalEntries: entriesCount,
                latestEntry: item.latestEntry,
                entityType: item.entityType,
                enumValues: item.enumValues,
              },
            ],
          });
        }
        return acc;
      }, [] as Array<MODIFIED_CASE_DOCUMENTATION>)
      .sort((a, b) => {
        const aHasEntries = a.actualEntries > 0;
        const bHasEntries = b.actualEntries > 0;

        // First, sort by entries status (items with entries > 0 come first)
        if (aHasEntries !== bHasEntries) {
          return bHasEntries ? 1 : -1;
        }

        // Then sort alphabetically by sectionName
        return a.sectionName.localeCompare(b.sectionName);
      });
  }, [caseDocumentationListData]);

  if (!caseDocumentationList || caseDocumentationList.length === 0) {
    return (
      <Box
        height="60vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <EmptyComponent title="No data to display" />
      </Box>
    );
  }
  return (
    <>
      <Box sx={{ width: "98%", mx: "auto", p: 2 }}>
        {caseDocumentationList?.map((item) => {
          return <CaseDocumentationItem key={item.sectionName} detail={item} />;
        })}
      </Box>
      <CaseTranscriptDrawer />
    </>
  );
};

export default CaseDocumentation;
